import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ComunicationService } from '../../Services/comunication.service';
import { UserService } from '../../Services/userservice.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  titulo:string = "Formularios";
  tipoind:number = 0;
  tiposend:string ="";
  isAdmin =  false;
  constructor(private userService: UserService, private router: Router, private comunicacion: ComunicationService) { 
    userService.changeEmitted$.subscribe(
      send => {
          this.tiposend = typeof(send);  
        if( this.tiposend == "string"){
          this.titulo= send;
        }else{
          this.tipoind= send;
        }
      }
  )

  }
  super = false
  logged = false
  ngOnInit(): void {
    this.comunicacion.obs_super.subscribe(data => {
      this.super = data;
      //console.log('Esto es lo que esta en super', this.super);
      if(this.super){
        this.isAdmin = true;
        //console.log('Esto es lo que esta en admin', this.isAdmin);
      }
      let rol = localStorage.getItem('role')

      if (rol) {
        this.logged = true
      }
    })


  }

  logout() {

    this.userService.logout()
    this.logged = false;
    this.super = false;
    this.router.navigate(['login']);
  }

  ocultardiv(){
    document.getElementsByName("divformuedit")[0].setAttribute("style", "display:none;");
    document.getElementsByName("botonpr")[0].setAttribute("style", "display: none;");
    document.getElementsByName("botonedit")[0].setAttribute("style", "display: block;");
    document.getElementsByName("divvisual")[0].setAttribute("style", "display:block;");
    document.getElementsByName("botonregreso")[0].setAttribute("style", "display: none;");
    
    this.titulo = "Previsualización del formulario";
  }
  mostrardiv(){
    //console.log('Se presiona este ');
    
    document.getElementsByName("divformuedit")[0].setAttribute("style", "display:block; background: #dcdcdd; min-height: 900px !important;");
    document.getElementsByName("botonpr")[0].setAttribute("style", "display: block;");
    document.getElementsByName("botonedit")[0].setAttribute("style", "display: none;");
    document.getElementsByName("divvisual")[0].setAttribute("style", "display:none;");
    document.getElementsByName("botonregreso")[0].setAttribute("style", "display: block;");
    if(this.tipoind==1){
      this.titulo = "Crear Formulario";
    }else{
      this.titulo = "Editar Formulario";
    }
        
  }


  public confirmar(){
   
    if(this.titulo == 'Crear Formulario' || this.titulo == 'Editar Formulario'){
      Swal.fire({
        title: '¿Esta seguro?',
        text: `Perderá su progreso en el formulario`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, regresar',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.isConfirmed) {
          this.router.navigate(['ini']);
          
        }
      })

    }
  }


  irAdminUsers(){
    this.router.navigateByUrl("/list-users")

  }

  irForms(){
    console.log('Ir a forms')
    this.router.navigateByUrl("/ini")
  }

}
